<template>
  <div class="position-edit-buttons">
    <span class="sr-only">{{ getAriaText(params) }}</span>
    <b-button
      class="edit"
      variant="link"
      @click="cta('edit')"
      ref="button1"
      @keydown="invokeFirstButtonPress"
      :aria-label="`${getAriaText(params)} ${$t('white-label.globalLabels.edit')}`"
      ><font-awesome-icon :icon="['fas', 'edit']"
    /></b-button>
    <b-button
      class="remove"
      variant="link"
      @click="cta('remove')"
      ref="button2"
      @keydown="invokeSecondButtonPress"
      :aria-label="`${getAriaText(params)} ${$t('white-label.globalLabels.delete')}`"
      ><font-awesome-icon :icon="['fas', 'times-circle']"
    /></b-button>
  </div>
</template>

<script>
import { library as fontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core';
import { faEdit, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { getAriaText } from '@utils/helpers';
fontAwesomeLibrary.add(faEdit, faTimesCircle);

export default {
  name: 'position-edit-renderer',
  methods: {
    getAriaText,
    cta(type) {
      this.params.context[`onPosition${type.replace(/./, c => c.toUpperCase())}Clicked`](this.params.data);
    },
    invokeSecondButtonPress(value) {
      this.params.context[`invokeTabNextCell`](value);
    },
    invokeFirstButtonPress(value) {
      const shiftTabkey = value.shiftKey && value.key === 'Tab';
      if (shiftTabkey) {
        this.params.context[`invokeTabPreviousCell`](value);
      }
    },
    onKeyDown(e) {
      let isButtonFocussed = e.target.tagName === 'BUTTON';
      let shiftTab = e.shiftKey && e.key === 'Tab';
      if (!isButtonFocussed && shiftTab) {
        e.preventDefault();
        this.$refs.button2.focus();
      }
    }
  },
  created() {
    this.params.eGridCell.addEventListener('keydown', this.onKeyDown);
  },
  beforeDestroy() {
    this.params.eGridCell.removeEventListener('keydown', this.onKeyDown);
  }
};
</script>
